import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { setPath } from '../../../utils/url'
import { URL } from '../../constants/url'
import { Link, useParams } from 'react-router-dom'
import Tips from './Tips'
import ImportProjectModal from '../task/ImportProjectModal'
import { useAlert } from 'react-alert'
import AnalyzeSupportModal from './AnalyzeSupportModal'

type LangValue = 'ja' | 'en'

interface Props {
  isOpen: boolean
  toggleCallback: VoidFunction
}

const SideBarSub: FC<Props> = (props) => {
  const {
    isOpen,
    toggleCallback,
  } = props

  const {
    login,
    task,
  } = useSelector((state: RootState) => state)
  const alert = useAlert()

  const { language } = useParams<{ language: LangValue }>()

  const [isOpenImportModal, setIsOpenImportModal] = useState<boolean>(false)
  const [isOpenAnalyzeSupportModal, setIsOpenAnalyzeSupportModal] = useState<boolean>(false)

  return (
    <>
      {
        location.pathname.match(URL.TASK.path)
        && login.function_enabled_state?.task_management ? (
          <>
            <div className="side_sub_wrap">
              <div className="tools">
                <div className="calendar_text">
                  <div />
                  <button
                    type="button"
                    className={`menu_toggle ${isOpen && "display"}`}
                    onClick={() => toggleCallback()}
                  >
                    <div className={`menu ${isOpen && "active"}`}>
                      <FontAwesomeIcon icon={['fas', 'angle-double-left']} />
                    </div>
                  </button>
                </div>
              </div>
              <section className="side_sub">
                <div>
                  <div className="item folder">
                    <div className="name_label">
                      <div className="name_area">
                        あなたのデータ
                      </div>
                    </div>
                  </div>
                  <Link
                    to={setPath(URL.TASK_LABELING_SELF.path, language)}
                    className={classNames({
                      active: location.pathname.match(URL.TASK_LABELING_SELF.path),
                      item: true,
                      indent_1: true,
                    })}
                  >
                    <div className="name_label">
                      <div className="name_area">
                        <FontAwesomeIcon
                          icon={['fas', 'tag']}
                          className="icon task"
                        />
                        業務仕分けボード
                      </div>
                    </div>
                  </Link>
                  {
                    login.function_enabled_state.task_management_approval ? (
                      <Link
                        to={setPath(URL.TASK_APPROVAL_SELF.path, language)}
                        className={classNames({
                          active: location.pathname.match(URL.TASK_APPROVAL_SELF.path),
                          item: true,
                          indent_1: true,
                        })}
                      >
                        <div className="name_label">
                          <div className="name_area">
                            <FontAwesomeIcon
                              icon={['fas', 'file-alt']}
                              className="icon task"
                            />
                            申請状況
                          </div>
                        </div>
                      </Link>
                    ) : (
                      <Tips
                        description="申請ユーザーとして設定された場合のみ閲覧できます"
                        className=""
                        icon={false}
                      >
                        <div className="item indent_1 disable">
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'file-alt']}
                                className="icon task"
                              />
                              申請状況
                            </div>
                          </div>
                        </div>
                      </Tips>
                    )
                  }
                </div>
                <div>
                  <div className="item folder">
                    <div className="name_label">
                      <div className="name_area">
                        各種レポート
                      </div>
                    </div>
                  </div>
                  {
                    login.feature_config?.task_report_view ? (
                      <>
                        <Link
                          to={setPath(URL.TASK.path, language)}
                          className={classNames({
                            active:
                              (location.pathname.match(URL.TASK.path) && location.pathname.split("/").length === 3)
                              || location.pathname.match("/task/task_detail/"),
                            item: true,
                            indent_1: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'file-alt']}
                                className="icon task"
                              />
                              プロジェクトレポート
                            </div>
                          </div>
                        </Link>
                      </>
                    ) : (
                      <Tips
                        description="プロジェクトレポート表示対象として設定された場合のみ該当のレポートを閲覧できます"
                        className=""
                        icon={false}
                      >
                        <div className="item indent_1 disable">
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'file-alt']}
                                className="icon task"
                              />
                              プロジェクトレポート
                            </div>
                          </div>
                        </div>
                      </Tips>
                    )
                  }
                  {
                    login.feature_config?.task_category_report_view ? (
                      <>
                        <Link
                          to={setPath(URL.TASK_CATEGORY_DETAIL.path, language)}
                          className={classNames({
                            active: location.pathname.match(URL.TASK_CATEGORY_DETAIL.path),
                            item: true,
                            indent_1: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'file-alt']}
                                className="icon task"
                              />
                              カテゴリーレポート
                            </div>
                          </div>
                        </Link>
                      </>
                    ) : (
                      <Tips
                        description="カテゴリー表示ユーザーとして設定された場合のみ該当のレポートを閲覧できます"
                        className=""
                        icon={false}
                      >
                        <div className="item indent_1 disable">
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'file-alt']}
                                className="icon task"
                              />
                              カテゴリーレポート
                            </div>
                          </div>
                        </div>
                      </Tips>
                    )
                  }
                  {
                    login.feature_config?.task_labeling_status_view ? (
                      <Link
                        to={setPath(URL.TASK_LABELING_STATUS.path, language)}
                        className={classNames({
                          active: location.pathname.match(URL.TASK_LABELING_STATUS.path),
                          item: true,
                          indent_1: true,
                        })}
                      >
                        <div className="name_label">
                          <div className="name_area">
                            <FontAwesomeIcon
                              icon={['fas', 'file-alt']}
                              className="icon task"
                            />
                            仕分け状況レポート
                          </div>
                        </div>
                      </Link>
                    ) : (
                      <Tips
                        description="仕分け状況レポートが閲覧できる権限が付与された場合のみ該当ユーザーの仕分け状況レポートを閲覧できます"
                        className=""
                        icon={false}
                      >
                        <div className="item indent_1 disable">
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'file-alt']}
                                className="icon task"
                              />
                              仕分け状況レポート
                            </div>
                          </div>
                        </div>
                      </Tips>
                    )
                  }
                  {
                    login.function_enabled_state.task_management_approval && login.feature_config?.task_approver ? (
                      <Link
                        to={setPath(URL.TASK_APPROVAL_STATUS.path, language)}
                        className={classNames({
                          active: location.pathname.match(URL.TASK_APPROVAL_STATUS.path),
                          item: true,
                          indent_1: true,
                        })}
                      >
                        <div className="name_label">
                          <div className="name_area">
                            <FontAwesomeIcon
                              icon={['fas', 'file-alt']}
                              className="icon task"
                            />
                            承認状況
                          </div>
                        </div>
                      </Link>
                    ) : (
                      <Tips
                        description="承認ユーザーまたは閲覧ユーザーとして設定された場合のみ閲覧できます"
                        className=""
                        icon={false}
                      >
                        <div className="item indent_1 disable">
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'file-alt']}
                                className="icon task"
                              />
                              承認状況
                            </div>
                          </div>
                        </div>
                      </Tips>
                    )
                  }
                  <div
                    className="item indent_1"
                    onClick={() => setIsOpenAnalyzeSupportModal(true)}
                    role="none"
                  >
                    <div className="name_label">
                      <div className="name_area">
                        <FontAwesomeIcon
                          icon={['fas', 'file-alt']}
                          className="icon task"
                        />
                        データ分析支援
                        <div
                          style={{
                            borderRadius: "4px",
                            backgroundColor: "#FF0000",
                            color: "#FFFFFF",
                            fontSize: "8px",
                            padding: "2px 4px",
                            marginLeft: "8px",
                          }}
                        >
                          NEW
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ margin: "0 8px" }}>
                  <div>
                    <div className="item folder no_border">
                      <div className="name_label">
                        <div
                          className="name_area"
                          style={{
                            backgroundColor: "#4d6eae",
                            padding: "8px 12px",
                            marginLeft: "-16px",
                            marginBottom: "-2px",
                            borderRadius: "4px 4px 0 0",
                          }}
                        >
                          操作
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#4D6EAE",
                      borderRadius: "0 8px 8px 8px",
                    }}
                  >
                    {
                      login.feature_config?.task_report_view ? (
                        <>
                          <Link
                            to={setPath(URL.TASK_BULK_LABELING.path, language)}
                            className={classNames({
                              active: location.pathname.match(URL.TASK_BULK_LABELING.path),
                              item: true,
                            })}
                          >
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'tags']}
                                  className="icon task"
                                />
                                一括仕分け
                              </div>
                            </div>
                          </Link>
                        </>
                      ) : (
                        <Tips
                          description="プロジェクトレポート表示対象ユーザーとして設定された場合のみ該当プロジェクトの一括仕分け操作ができます"
                          className=""
                          icon={false}
                        >
                          <div className="item disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'tags']}
                                  className="icon task"
                                />
                                一括仕分け
                              </div>
                            </div>
                          </div>
                        </Tips>
                      )
                    }
                    {
                      (login.feature_config?.task_project_setting_view || login.role_permission?.task_project_member_setting) ? (
                        <Link
                          to={setPath(URL.TASK_LABEL_SETTING.path, language)}
                          className={classNames({
                            active: location.pathname.match(URL.TASK_LABEL_SETTING.path),
                            item: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'cog']}
                                className="icon task"
                              />
                              プロジェクト設定
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <Tips
                          description="プロジェクト設定権限が付与された場合のみ操作ができます"
                          className=""
                          icon={false}
                        >
                          <div className="item disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'cog']}
                                  className="icon task"
                                />
                                プロジェクト設定
                              </div>
                            </div>
                          </div>
                        </Tips>
                      )
                    }
                    {
                      (login.role_permission?.task_project_import) ? (
                        <>
                          <div
                            className="item"
                            onClick={() => setIsOpenImportModal(true)}
                            role="none"
                          >
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'cog']}
                                  className="icon task"
                                />
                                プロジェクトインポート
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <Tips
                          description="プロジェクトインポート権限が付与された場合のみ操作ができます"
                          className=""
                          icon={false}
                        >
                          <div className="item disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'cog']}
                                  className="icon task"
                                />
                                プロジェクトインポート
                              </div>
                            </div>
                          </div>
                        </Tips>
                      )
                    }
                    <Link
                      to={setPath(URL.TASK_AUTO_LABELING.path, language)}
                      className={classNames({
                        active: location.pathname.match(URL.TASK_AUTO_LABELING.path),
                        item: true,
                      })}
                    >
                      <div className="name_label">
                        <div className="name_area">
                          <FontAwesomeIcon
                            icon={['fas', 'cog']}
                            className="icon task"
                          />
                          自動仕分け設定
                        </div>
                      </div>
                    </Link>
                    {
                      login.role_permission?.task_category_setting ? (
                        <Link
                          to={setPath(URL.TASK_PROJECT_CATEGORY.path, language)}
                          className={classNames({
                            active: location.pathname.match(URL.TASK_PROJECT_CATEGORY.path),
                            item: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'cog']}
                                className="icon task"
                              />
                              カテゴリー設定
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <Tips
                          description="カテゴリー管理権限が付与された場合のみ操作ができます"
                          className=""
                          icon={false}
                        >
                          <div className="item disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'cog']}
                                  className="icon task"
                                />
                                カテゴリー設定
                              </div>
                            </div>
                          </div>
                        </Tips>
                      )
                    }
                    {
                      login.role_permission?.task_label_master_setting ? (
                        <>
                          <Link
                            to={setPath(URL.TASK_MASTER.path, language)}
                            className={classNames({
                              active: location.pathname.match(URL.TASK_MASTER.path),
                              item: true,
                            })}
                          >
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'cog']}
                                  className="icon task"
                                />
                                業務設定
                              </div>
                            </div>
                          </Link>
                        </>
                      ) : (
                        <>
                          <Tips
                            description="業務設定権限が付与された場合のみ操作ができます"
                            className=""
                            icon={false}
                          >
                            <div className="item disable">
                              <div className="name_label">
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'cog']}
                                    className="icon task"
                                  />
                                  業務設定
                                </div>
                              </div>
                            </div>
                          </Tips>
                        </>
                      )
                    }
                    {
                      login.role_permission?.task_target_service_setting ? (
                        <>
                          <Link
                            to={setPath(URL.TASK_TARGET_SERVICE_SETTING.path, language)}
                            className={classNames({
                              active: location.pathname.match(URL.TASK_TARGET_SERVICE_SETTING.path),
                              item: true,
                            })}
                          >
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'cog']}
                                  className="icon task"
                                />
                                仕分け対象アプリ設定
                              </div>
                            </div>
                          </Link>
                        </>
                      ) : (
                        <>
                          <Tips
                            description="仕分け対象アプリ設定権限が付与された場合のみ操作ができます"
                            className=""
                            icon={false}
                          >
                            <div className="item disable">
                              <div className="name_label">
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'cog']}
                                    className="icon task"
                                  />
                                  仕分け対象アプリ設定
                                </div>
                              </div>
                            </div>
                          </Tips>
                        </>
                      )
                    }
                    {
                      login.role_permission?.task_member_cost_setting ? (
                        <Link
                          to={setPath(URL.TASK_COST.path, language)}
                          className={classNames({
                            active: location.pathname.match(URL.TASK_COST.path),
                            item: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'cog']}
                                className="icon task"
                              />
                              ユーザーコスト設定
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <Tips
                          description="ユーザーコスト設定権限が付与された場合のみ操作ができます"
                          className=""
                          icon={false}
                        >
                          <div className="item disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'cog']}
                                  className="icon task"
                                />
                                ユーザーコスト設定
                              </div>
                            </div>
                          </div>
                        </Tips>
                      )
                    }
                    {
                      (login.feature_config?.task_report_view || login.role_permission?.task_attendance_export) ? (
                        <Link
                          to={setPath(URL.TASK_CSV_EXPORT.path, language)}
                          className={classNames({
                            active: location.pathname.match(URL.TASK_CSV_EXPORT.path),
                            item: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'file-csv']}
                                className="icon task"
                              />
                              データエクスポート
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <Tips
                          description="プロジェクトレポート表示対象ユーザーとして設定された場合のみ操作ができます"
                          className=""
                          icon={false}
                        >
                          <div className="item disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'file-csv']}
                                  className="icon task"
                                />
                                データエクスポート
                              </div>
                            </div>
                          </div>
                        </Tips>
                      )
                    }
                    <Link
                      to={setPath(URL.TASK_SEARCH.path, language)}
                      className={classNames({
                        active: location.pathname.match(URL.TASK_SEARCH.path),
                        item: true,
                      })}
                    >
                      <div className="name_label">
                        <div className="name_area">
                          <FontAwesomeIcon
                            icon={['fas', 'search']}
                            className="icon task"
                          />
                          検索
                        </div>
                      </div>
                    </Link>
                    {
                      login.role_name ? (
                        <Link
                          to={`${setPath(URL.SETTING_COMMON.path, language)}#task_other`}
                          className={classNames({
                            item: true,
                            no_border: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'ellipsis-h']}
                                className="icon task"
                              />
                              その他
                              <FontAwesomeIcon
                                icon={['fas', 'external-link-alt']}
                                pull="right"
                                className="external"
                              />
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <Tips
                          description="いずれかのロール権限が付与された場合のみ操作ができます"
                          className=""
                          icon={false}
                        >
                          <div className="item no_border disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'ellipsis-h']}
                                  className="icon task"
                                />
                                その他
                                <FontAwesomeIcon
                                  icon={['fas', 'external-link-alt']}
                                  pull="right"
                                  className="external"
                                />
                              </div>
                            </div>
                          </div>
                        </Tips>
                      )
                    }
                  </div>
                </div>
              </section>
            </div>
            <div className="task_page">
              <ImportProjectModal
                isDisplay={isOpenImportModal}
                dataList={task.taskLabelGroupImport}
                closeCallback={() => setIsOpenImportModal(false)}
                addCallback={() => { alert.success("プロジェクト一括登録を受け付けました") }}
                isCost
              />
            </div>
            <AnalyzeSupportModal
              display={isOpenAnalyzeSupportModal}
              closeCallback={() => setIsOpenAnalyzeSupportModal(false)}
            />
          </>
          ) : (
            <>
            </>
          )
      }
    </>
  )
}

export default SideBarSub
